import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import SidebarLink from "./sidebarLink"
import ThemedTag from "../pages/themedTag"

const CurrentPageListItem = styled.div`
  margin: ${props => `${props.theme.space.xs} ${props.theme.space.xs}`};
  padding: ${props => props.theme.space.xs};
  color: ${props => props.theme.colors.sidebar.foreground};
  background-color: ${props => props.theme.colors.sidebar.linkBackgroundActive};
  border-radius: ${props => props.theme.borderRadii.md};
  ${props =>
    props.$isTopLevel &&
    `font-weight: ${props.theme.fontWeights.semibold};
     font-size: ${props.theme.fontSizes.lg};`}
  ${props => props.$isNested && `margin-right: 0;`}
`

const StyledThemedTag = styled(ThemedTag)`
  margin-left: ${props => props.theme.space.md};
`

const SidebarListItem = ({
  item,
  currentPage,
  isNested,
  isTopLevel,
  isFocusable
}) => {
  const { title, link, tag } = item
  const dataTestId = `dev-docs-sidebar-link-${link.replace(/\//gi, "-")}`
  const home = link === "/"
  const external = /^https?:\/\//i.test(link)
  const relativePath = home || external ? link : `/${link}/`

  const listItemEl =
    relativePath === currentPage ? (
      <CurrentPageListItem $isNested={isNested} $isTopLevel={isTopLevel}>
        {title}
      </CurrentPageListItem>
    ) : (
      <SidebarLink
        isNested={isNested}
        isTopLevel={isTopLevel}
        tabIndex={isFocusable ? 0 : -1}
        to={relativePath}
        external={external}
      >
        {title}
        {tag && (
          <StyledThemedTag>
            {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
            <>{tag}</>
          </StyledThemedTag>
        )}
      </SidebarLink>
    )
  return <li data-testid={dataTestId}>{listItemEl}</li>
}

SidebarListItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string,
    tag: PropTypes.string
  }).isRequired,
  currentPage: PropTypes.string,
  isNested: PropTypes.bool,
  isTopLevel: PropTypes.bool,
  isFocusable: PropTypes.bool
}

SidebarListItem.defaultProps = {
  currentPage: null,
  isNested: false,
  isTopLevel: false,
  isFocusable: true
}

export default SidebarListItem
